import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M4 4C2.875 4 2 4.9375 2 6V26C2 27.125 2.875 28 4 28H28C29.0625 28 30 27.125 30 26V10C30 8.9375 29.0625 8 28 8H18.1875C17.125 8 16.125 7.625 15.375 6.875L13.125 4.625C12.75 4.25 12.25 4 11.75 4H4ZM0 6C0 3.8125 1.75 2 4 2H11.75C12.8125 2 13.8125 2.4375 14.5625 3.1875L16.8125 5.4375C17.1875 5.8125 17.6875 6 18.1875 6H28C30.1875 6 32 7.8125 32 10V26C32 28.25 30.1875 30 28 30H4C1.75 30 0 28.25 0 26V6Z'],
  name: 'uiFolder',
  oldName: 'falFolder'
} as IconDefinition
